// Screen that tells the user what is going on
import { Flex, Typography } from '@aloft/toolkit-sui';

export const MissingDataWarning = ({
  isSubjectGlaDefined,
  isSubjectLotSizeDefined,
  isSubjectLocationDefined,
}: {
  isSubjectGlaDefined: boolean;
  isSubjectLotSizeDefined: boolean;
  isSubjectLocationDefined: boolean;
}) => {
  const isMissingInput = !isSubjectGlaDefined || !isSubjectLotSizeDefined;
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      gap="5rem"
      justifyContent="center"
      height="100%"
    >
      <Flex flexDirection="column" gap="1rem" alignItems="center">
        <Typography variant="h2">Find Recommended Comps</Typography>
        <Typography variant="body1">
          Find recommended comparables based on similarity to the subject property.
        </Typography>
        {!isSubjectLocationDefined && (
          <Typography variant="body1" color="alertError">
            Subject property location cannot be found. Please update subject address to enable this
            feature.
          </Typography>
        )}
        {isMissingInput && (
          <Typography variant="body1" color="alertError">
            Please enter subject property&apos;s GLA and Lot Size to enable this feature.
          </Typography>
        )}
      </Flex>
    </Flex>
  );
};
